import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { WEB_COMPONENT_TAGS_MANAGER_GRID } from '../../../webcomponents.constants';
import { TagsManagerGridWebComponent } from '../../tagsManagerGrid';
import { Dependencies } from '../../types/dependencies';

export class TagsManagerView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $tagsManagerGrid: TagsManagerGridWebComponent;
  };

  public dependencies: Dependencies;

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $tagsManagerGrid: this.shadow.querySelector(WEB_COMPONENT_TAGS_MANAGER_GRID),
    };
  }

  public buildSuccessView(data: any) {
    if (!this.dom.$tagsManagerGrid.started) {
      this.dom.$tagsManagerGrid.injectDependencies(this.dependencies);
      this.dom.$tagsManagerGrid.start().then().catch(console.error);
    }
  }
}
